import React, { Suspense } from 'react';
import { useIsMobile } from '../../../../../../platform/util/utils';

// Dynamically import the WeekNavigation components for desktop and mobile
const WeekNavigationDesktop = React.lazy(() => import('./weekNavigation_desktop')); // Desktop version
const WeekNavigationMobile = React.lazy(() => import('./weekNavigation_mobile'));   // Mobile version

const WeekNavigation = () => {
  const isMobile = useIsMobile();
  return (
    <Suspense fallback={<div>Loading...</div>}>
      {/* Conditionally render the mobile or desktop version based on screen size */}
      {isMobile ? <WeekNavigationMobile /> : <WeekNavigationDesktop />}
    </Suspense>
  );
};

export default WeekNavigation;
